module.exports = __webpack_public_path__ + "img/logo.ad575ee1.png";